export default "__VITE_ASSET__BVP14Uec__"